export const formatDate = (date) => {
  if (!date) return '';
  const dt = new Date(date);
  if (isNaN(dt.getTime())) return '';
  const year = dt.getFullYear();
  const month = String(dt.getMonth() + 1).padStart(2, '0'); 
  const day = String(dt.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`; 
}


export const getMonthName = (month) => {
  switch(month)
  {
    case 0:
      return "Jan";
    case 1:
      return "Feb";
    case 2:
      return "Mar";
    case 3:
      return "Apr";
    case 4:
      return "May";
    case 5:
      return "Jun";
    case 6:
      return "Jul";
    case 7:
      return "Aug";
    case 8:
      return "Sep";
    case 9:
      return "Oct";
    case 10:
      return "Nov";
    case 11:
      return "Dec";
    default:
      return "Jan";
  }
}

function isValidCalendarDate(year, monthIndex, day) {
  const d = new Date(year, monthIndex, day);
  return (
    d.getFullYear() === year &&
    d.getMonth() === monthIndex &&
    d.getDate() === day
  );
}


// Lowercase the second word of check-in/out states so IFS-supplied text
// (e.g. "Checked-In", "Check-Out") matches the rest of the UI: "Checked-in", "Check-out".
const normalizeCheckStateCasing = (text) =>
  text
    .replace(/\bChecked[-\s]In\b/g, "Checked-in")
    .replace(/\bChecked[-\s]Out\b/g, "Checked-out")
    .replace(/\bCheck[-\s]In\b/g, "Check-in")
    .replace(/\bCheck[-\s]Out\b/g, "Check-out");

export const formatIfsDocumentLastActionDisplay = (lastAction) => {
  if (!lastAction) return "-";

  const raw = String(lastAction);
  const m = raw.match(/^(\d{2})-(\d{2})-(\d{2})([\s\S]*)$/);
  if (m) {
    const mm = parseInt(m[1], 10);
    const dd = parseInt(m[2], 10);
    const yy = parseInt(m[3], 10);
    const year = yy < 100 ? 2000 + yy : yy;
    if (mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31 && isValidCalendarDate(year, mm - 1, dd)) {
      const prefix = `${year}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`; // ISO 8601: YYYY-MM-DD
      // Split camelCase only; do not insert before every capital (breaks "Checked-Out" → "Checked- Out").
      const rest = m[4]
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ");
      return normalizeCheckStateCasing((prefix + rest).trim());
    }
  }

  return normalizeCheckStateCasing(
    raw
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim()
  );
};